/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hide_On_StartupInputs */

const en_hide_on_startup = /** @type {(inputs: Hide_On_StartupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hide on startup`)
};

const fr_hide_on_startup = /** @type {(inputs: Hide_On_StartupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masquer au démarrage`)
};

const de_hide_on_startup = /** @type {(inputs: Hide_On_StartupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beim Start ausblenden`)
};

const it_hide_on_startup = /** @type {(inputs: Hide_On_StartupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nascondi all'avvio`)
};

const ru_hide_on_startup = /** @type {(inputs: Hide_On_StartupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Скрыть при запуске`)
};

const es_hide_on_startup = /** @type {(inputs: Hide_On_StartupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ocultar al iniciar`)
};

const zh_cn2_hide_on_startup = /** @type {(inputs: Hide_On_StartupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`启动时隐藏`)
};

const ja_hide_on_startup = /** @type {(inputs: Hide_On_StartupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`起動時に非表示にする`)
};

const hi_hide_on_startup = /** @type {(inputs: Hide_On_StartupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्टार्टअप पर छिपाएँ`)
};

const pt_pt2_hide_on_startup = /** @type {(inputs: Hide_On_StartupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ocultar na inicialização`)
};

/**
* | output |
* | --- |
* | "Hide on startup" |
*
* @param {Hide_On_StartupInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const hide_on_startup = /** @type {((inputs?: Hide_On_StartupInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hide_On_StartupInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_hide_on_startup(inputs)
	if (locale === "de") return de_hide_on_startup(inputs)
	if (locale === "it") return it_hide_on_startup(inputs)
	if (locale === "ru") return ru_hide_on_startup(inputs)
	if (locale === "es") return es_hide_on_startup(inputs)
	if (locale === "zh-CN") return zh_cn2_hide_on_startup(inputs)
	if (locale === "ja") return ja_hide_on_startup(inputs)
	if (locale === "hi") return hi_hide_on_startup(inputs)
	if (locale === "pt-PT") return pt_pt2_hide_on_startup(inputs)
	return en_hide_on_startup(inputs)
});